import { Box, Grid2, Paper, Typography, useTheme } from '@mui/material'

import ToothGraphic5 from '@/assets/images/Tooth-graphic-5.svg'
import Chip from '@/components/Chip'
import PieChart from '@/components/PieChart'
import { isNullorEmpty } from '@/utils'
import { pieChartSections } from '@/utils/constants'
import { analogRecipeChart } from '@/utils/matisseV2/analog'

type StumpShadePDFProps = {
  recipeOutput: any
  stainingbrand: string
  restorationMethodOnRecipeGenerate: string
}

const PieChartCard = ({
  title,
  labels,
  values,
  stainingTarget,
  restorationMethodOnRecipeGenerate,
}: {
  title: string
  labels?: string[]
  values?: number[]
  stainingTarget?: string
  restorationMethodOnRecipeGenerate?: string
}) => {
  if (!labels?.length || !values?.length) return null

  return (
    <Paper
      elevation={3}
      sx={{
        flex: 1,
        p: 3,
        textAlign: 'center',
        borderRadius: '16px',
        color: 'black',
        height: '100%',
        maxWidth: '31%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'white',
        boxShadow: 'none',
      }}
    >
      <Box display="flex" alignItems="center" gap={1} mb={1}>
        <Typography variant="h4" fontWeight="bold">
          {title}
        </Typography>
      </Box>
      <Box
        flexGrow={1}
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
        gap="8px"
      >
        <PieChart labels={labels} values={values} />
        {restorationMethodOnRecipeGenerate !== 'staining' && (
          <Typography>Staining target : {stainingTarget}</Typography>
        )}
      </Box>
    </Paper>
  )
}

const StainingAndWashBakePDF = ({
  recipeOutput,
  stainingbrand,
  restorationMethodOnRecipeGenerate,
}: StumpShadePDFProps) => {
  const theme = useTheme()

  return (
    <Box
      display="flex"
      mt={1}
      // height="100%"
      sx={{
        color: 'black',
        borderBottom: '1px solid #000',
        marginBottom: '8px',
        background: 'white',
      }}
    >
      <Box sx={{ width: '30%' }}>
        <img
          style={{ width: '270px', height: '380px' }}
          src={ToothGraphic5}
          alt="Toothimage"
        />
      </Box>
      <Box
        flex={1}
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="start"
        mt={1}
        height="100%"
        sx={{
          color: 'black',
        }}
      >
        <Box
          display="flex"
          flex={1}
          justifyContent="center"
          alignItems="center"
          my={2}
          gap={1}
        >
          <Typography
            sx={{ fontSize: '1.5rem', fontWeight: 500, color: '#000' }}
          >
            {restorationMethodOnRecipeGenerate === 'staining'
              ? 'Staining'
              : 'Wash Bake'}
            :
          </Typography>
          {isNullorEmpty(stainingbrand) && (
            <Chip
              label={stainingbrand}
              sx={{
                bgcolor: theme.palette.background.chip,
                fontSize: '16px',
                color: theme.palette.common.black,
                '&:hover': {
                  bgcolor: theme.palette.background.chip,
                },
              }}
            />
          )}
        </Box>

        <Grid2
          container
          spacing={3}
          justifyContent="center"
          alignItems="stretch"
          mb={2}
          columns={3}
          width="100%"
        >
          {pieChartSections?.map(({ key, label }) => {
            const chart = analogRecipeChart(
              recipeOutput?.[`stainingrecipe_${key}`],
            )
            const stainingTarget = recipeOutput?.[`stainingtarget_${key}`] || ''
            return (
              <PieChartCard
                key={key}
                title={label}
                labels={chart.labels}
                values={chart.values as number[]}
                stainingTarget={stainingTarget}
                restorationMethodOnRecipeGenerate={
                  restorationMethodOnRecipeGenerate
                }
              />
            )
          })}
        </Grid2>
      </Box>
    </Box>
  )
}

export default StainingAndWashBakePDF
